/**
 * @module manifest/panelLayout
 * @description Config A 入口：各图表类型的 Tab × 设置组 id 面板布局
 *
 * 数据流：
 *   Panel: PANEL_LAYOUT_BY_CHART[chartType] → layoutToResolvedGroups 注入显隐
 *   convert(): 从 PANEL_LAYOUT_BY_CHART[chartType] 收集组 id → upload-keys
 */

import { ChartType, type TChartType } from '@dbl/core/chart';
import type { PanelTabLayout } from './types';
import { LINE_FAMILY_PANEL_LAYOUT } from './lineFamily';
import { BAR_FAMILY_PANEL_LAYOUT } from './barFamily';
import { TABLE_PANEL_LAYOUT } from './table';
import { SIMPLE_CHART_PANEL_LAYOUT } from './simpleCharts';

const PANEL_LAYOUT_BY_CHART: Record<TChartType, PanelTabLayout[]> = {
  ...LINE_FAMILY_PANEL_LAYOUT,
  ...BAR_FAMILY_PANEL_LAYOUT,
  ...TABLE_PANEL_LAYOUT,
  ...SIMPLE_CHART_PANEL_LAYOUT,

  [ChartType.BigNumber]: [],
  [ChartType.Trend]: [],
  [ChartType.DimNumberTrend]: [],
};

export default PANEL_LAYOUT_BY_CHART;
export { PANEL_LAYOUT_BY_CHART };
export type { PanelTabLayout, LayoutGroupWithVisibility } from './types';
export {
  layoutToResolvedGroupsForIds,
  layoutToResolvedGroups,
} from './resolveLayout';

